
<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="600"
      @keydown.esc="$emit('close')"
      @keydown.enter="$emit('save')"
    >
      <template v-slot:default>
        <v-card>
          <v-card-title
            class="primary white--text"
          >
            <slot name="title"></slot>
          </v-card-title>
          
          <div class="px-5 pt-5">
            <slot name="content"></slot>
          </div>
          <v-card-actions class="justify-end">
            <slot name="actions"></slot>
          </v-card-actions>
        </v-card>
        </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'FDialog',
  props: {
    dialog: {
      type:Boolean,
      default: false,
    }
  },
  data() {
    return {

    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>